module.exports = __webpack_public_path__ + "static/media/forgot-password-email.5f6b38e9.svg";